<app-auth-shell>
  <form class="auth-card" (ngSubmit)="handleSubmit()">
    <div class="auth-card__header">
      <span class="auth-card__ornament" aria-hidden="true">⟡ ❖ ⟡</span>
      <h1>Reset Password</h1>
      <p>We'll help you get back into your account</p>
    </div>

    @if (resetComplete()) {
      <div class="auth-card__success">
        <span aria-hidden="true">✅</span>
        <p>Your password has been reset successfully.</p>
      </div>

      <a [routerLink]="routes.AUTH.LOGIN" class="auth-card__submit auth-card__submit--link">
        <span aria-hidden="true">⇥</span>
        Back to Login
      </a>
    } @else {
      <div class="auth-card__tabs" role="tablist">
        <button
          type="button"
          role="tab"
          class="auth-card__tab"
          [class.auth-card__tab--active]="method() === 'phone'"
          [attr.aria-selected]="method() === 'phone'"
          (click)="setMethod('phone')"
        >
          <span aria-hidden="true">📱</span> Phone
        </button>
        <button
          type="button"
          role="tab"
          class="auth-card__tab"
          [class.auth-card__tab--active]="method() === 'email'"
          [attr.aria-selected]="method() === 'email'"
          (click)="setMethod('email')"
        >
          <span aria-hidden="true">✉️</span> Email
        </button>
      </div>

      <div class="auth-card__field">
        <p class="auth-card__step-label">1. Enter your {{ method() === 'phone' ? 'phone number' : 'email address' }}</p>
        @if (method() === 'phone') {
          <app-country-phone-input
            [(country)]="country"
            [(phoneNumber)]="phone"
            placeholder="Enter your phone number"
          ></app-country-phone-input>
        } @else {
          <div class="auth-card__input-wrapper">
            <span aria-hidden="true">✉️</span>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              [(ngModel)]="email"
              required
            />
          </div>
        }
        <p class="auth-card__hint">We will send a 6-digit verification code to your registered {{ method() === 'phone' ? 'phone number' : 'email address' }}</p>
        @if (isDummyMode) {
          <p class="auth-card__demo-hint">
            @if (method() === 'phone') {
              Demo: 9036087945 / 9108078692 · OTP 123456
            } @else {
              Demo: user&#64;amaalmomineen.com / admin&#64;amaalmomineen.com · OTP 123456
            }
          </p>
        }
      </div>

      @if (otpSent()) {
        <div class="auth-card__field">
          <p class="auth-card__step-label">2. Enter 6-digit OTP</p>
          <app-otp-input [(code)]="otpCode" (resend)="sendOtp()"></app-otp-input>
        </div>

        <div class="auth-card__field">
          <p class="auth-card__step-label">3. Set a new password</p>
          <label for="reset-new-password">New Password</label>
          <div class="auth-card__input-wrapper">
            <span aria-hidden="true">🔒</span>
            <input
              id="reset-new-password"
              [type]="newPasswordVisible() ? 'text' : 'password'"
              name="newPassword"
              placeholder="Create a new password"
              [(ngModel)]="newPassword"
              required
            />
            <button type="button" class="auth-card__eye-toggle" (click)="toggleNewPasswordVisibility()" [attr.aria-label]="newPasswordVisible() ? 'Hide password' : 'Show password'">
              {{ newPasswordVisible() ? '🙈' : '👁️' }}
            </button>
          </div>
          <ul class="auth-card__requirements">
            <li [class.auth-card__requirement--met]="hasMinLength()">
              <span aria-hidden="true">{{ hasMinLength() ? '✅' : '⭕' }}</span> 8+ characters
            </li>
            <li [class.auth-card__requirement--met]="hasNumber()">
              <span aria-hidden="true">{{ hasNumber() ? '✅' : '⭕' }}</span> One number
            </li>
            <li [class.auth-card__requirement--met]="hasSpecialChar()">
              <span aria-hidden="true">{{ hasSpecialChar() ? '✅' : '⭕' }}</span> One special character
            </li>
          </ul>
        </div>

        <div class="auth-card__field">
          <label for="reset-confirm-password">Confirm New Password</label>
          <div class="auth-card__input-wrapper">
            <span aria-hidden="true">🔒</span>
            <input
              id="reset-confirm-password"
              [type]="confirmPasswordVisible() ? 'text' : 'password'"
              name="confirmPassword"
              placeholder="Confirm your new password"
              [(ngModel)]="confirmPassword"
              required
            />
            <button
              type="button"
              class="auth-card__eye-toggle"
              (click)="toggleConfirmPasswordVisibility()"
              [attr.aria-label]="confirmPasswordVisible() ? 'Hide password' : 'Show password'"
            >
              {{ confirmPasswordVisible() ? '🙈' : '👁️' }}
            </button>
          </div>
        </div>
      }

      @if (errorMessage()) {
        <p class="auth-card__error" role="alert">{{ errorMessage() }}</p>
      }

      <button type="submit" class="auth-card__submit" [disabled]="submitDisabled()">
        <span aria-hidden="true">{{ otpSent() ? '🔒' : '➤' }}</span>
        {{ submitLabel() }}
      </button>

      <p class="auth-card__footer-link">
        Remember your password? <a [routerLink]="routes.AUTH.LOGIN">Login</a>
      </p>
    }
  </form>
</app-auth-shell>
